import { render, staticRenderFns } from "./BalanceMenuButton.vue?vue&type=template&id=13687dc4&scoped=true"
import script from "./BalanceMenuButton.vue?vue&type=script&lang=ts"
export * from "./BalanceMenuButton.vue?vue&type=script&lang=ts"
import style0 from "./BalanceMenuButton.vue?vue&type=style&index=0&id=13687dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13687dc4",
  null
  
)

export default component.exports